import * as React from 'react';
import TextField from '@mui/material/TextField';
import StaticDateRangePicker from '@mui/lab/StaticDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Paper from "@mui/material/Paper";
import useOutsideClick from "../util/useOutsideClick";
import trLocale from 'date-fns/locale/tr';
import Button from "@mui/material/Button";

const DateRangePickerPopup = ({ anchorEl, setAnchorEl, value, setValue, mode, minDate, maxDate, onClear }) => {

    const open = Boolean(anchorEl);
    const wapperRef = useOutsideClick(() => setAnchorEl(null))

    // Temporary state to hold the selected value until confirmed
    const [tempValue, setTempValue] = React.useState(value);

    const handleConfirm = () => {
        if (tempValue == null) {
            onClear();
        } else {
            setValue(tempValue);
        }
        setAnchorEl(null);
    };

    const handleClear = () => {
        onClear();
        setAnchorEl(null);
    }

    return (
        <Popper open={open} anchorEl={anchorEl}>
            <Paper ref={wapperRef}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                    <StaticDateRangePicker
                        views={mode}
                        minDate={minDate}
                        maxDate={maxDate}
                        displayStaticWrapperAs="desktop"
                        value={value}
                        onChange={(newValue) => {
                            setTempValue(newValue);
                        }}
                        renderInput={(startProps, endProps) => (
                            <React.Fragment>
                                <TextField {...startProps} />
                                <Box sx={{ mx: 2 }}> to </Box>
                                <TextField {...endProps} />
                            </React.Fragment>
                        )}
                    />
                </LocalizationProvider>

                <div style={{ textAlign: "right", padding: 12, color: "red", position: "relative" }}>
                    <Button variant="contained" onClick={() => handleConfirm()} >TAMAM</Button>
                    <Button variant="text" onClick={() => handleClear()}>TEMİZLE</Button>
                </div>
                
            </Paper>
        </Popper>
    );

}

export default DateRangePickerPopup;
